/* global angular, ScrollReveal */
angular.module('ua5App')
    .directive('scrollReveal', ['$rootScope', '$timeout', function($rootScope, $timeout) {
        return {
            restrict: 'A',
            scope: {
                scrollRevealDelay: '@',
                scrollRevealDelayRandom: '@',
                scrollRevealDistance: '@',
                scrollRevealDuration: '@',
                scrollRevealEase: '@',
                scrollRevealOrigin: '@',
                scrollRevealStartingOpacity: '@'
            },
            link: function($scope, element, attrs) {
                if (!window.scrollReveal) {
                    window.scrollReveal = new ScrollReveal();
                }

                $scope.scrollRevealDelay = $scope.scrollRevealDelay || 300;
                $scope.scrollRevealOrigin = $scope.scrollRevealOrigin || 'bottom';
                $scope.scrollRevealDistance = $scope.scrollRevealDistance || '40px';
                $scope.scrollRevealDuration = $scope.scrollRevealDuration || 400;
                $scope.scrollRevealEase = $scope.scrollRevealEase || 'cubic-bezier(0.200, 0.485, 0.205, 1)';
                $scope.scrollRevealStartingOpacity = $scope.scrollRevealStartingOpacity || 0;

                if ($scope.scrollRevealDelayRandom) {
                    $scope.scrollRevealDelay = 50 + Math.random() * 400;
                }

                window.scrollReveal.reveal(element, {
                    origin: $scope.scrollRevealOrigin,
                    distance: $scope.scrollRevealDistance,
                    duration: $scope.scrollRevealDuration,
                    delay: $scope.scrollRevealDelay,
                    easing: $scope.scrollRevealEase,
                    opacity: $scope.scrollRevealStartingOpacity,
                    scale: 1,
                    reset: false,
                    viewFactor: 0.01,
                    viewOffset: {right: -200}
                });
            }
        };
    }])
;
